import React from 'react';
import { Link } from 'react-router-dom';
import { Play, ArrowRight, Calendar } from 'lucide-react';
import { contactInfo } from '../mock';

const thumbOf = (v) => v.thumb || `https://i.ytimg.com/vi/${v.youtubeId}/maxresdefault.jpg`;

// A single featured video centered at the top of a section, with supporting text + CTAs.
const FeatureVideoSection = ({ id, eyebrow, heading, blurb, video, viewAllTo, viewAllLabel, onPlay }) => (
  <section id={id} className="max-w-4xl mx-auto px-6 py-20 md:py-28 text-center" data-testid={`section-${id}`}>
    <p className="font-display tracking-[0.4em] text-[#c9a85f] text-sm uppercase mb-6">{eyebrow}</p>

    <button
      onClick={() => onPlay(video.youtubeId, video.title)}
      data-testid={`${id}-feature-video`}
      className="group relative block w-full rounded-2xl overflow-hidden aspect-video border border-white/10 hover:border-[#c9a85f]/60 transition-colors mb-10"
    >
      <img src={thumbOf(video)} alt={video.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-black/40 group-hover:bg-black/25 transition-colors" />
      <span className="absolute inset-0 flex items-center justify-center">
        <span className="flex items-center justify-center w-16 h-16 rounded-full bg-[#c9a85f]/90 text-black group-hover:scale-110 transition-transform shadow-xl">
          <Play size={24} className="fill-black ml-1" />
        </span>
      </span>
    </button>

    <h2 className="font-display font-bold text-white text-4xl md:text-5xl uppercase leading-[1.05]">{heading}</h2>
    {blurb && <p className="mt-5 text-white/75 text-base md:text-lg max-w-2xl mx-auto font-normal">{blurb}</p>}

    <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
      <a
        href={contactInfo.calendly}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${id}-book-call`}
        className="inline-flex items-center gap-2 bg-[#c9a85f] hover:bg-[#d8b970] text-black font-display font-semibold px-7 py-3.5 rounded-md transition-colors tracking-wide"
      >
        <Calendar size={18} /> Book A Call
      </a>
      {viewAllTo && (
        <Link
          to={viewAllTo}
          onClick={() => window.scrollTo(0, 0)}
          data-testid={`${id}-view-all`}
          className="group inline-flex items-center gap-3 border border-[#c9a85f]/50 hover:bg-[#c9a85f] hover:text-black text-white font-display font-semibold px-7 py-3.5 rounded-md transition-colors tracking-wide"
        >
          {viewAllLabel}
          <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      )}
    </div>
  </section>
);

export default FeatureVideoSection;
